import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, TransitionGroup as _TransitionGroup } from "vue";
const _hoisted_1 = { class: "with-sides-left" };
const _hoisted_2 = { class: "sidebar" };
const _hoisted_3 = {
    class: "accordion-wrapper variant-primary",
    "data-close-other": ""
};
const _hoisted_4 = { class: "accordion__intro" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("button", { class: "toggle-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--add-fill" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--subtract-fill" })
], -1);
const _hoisted_6 = { class: "accordion__content" };
const _hoisted_7 = ["value"];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-right-line" }, null, -1);
const _hoisted_9 = { class: "title" };
const _hoisted_10 = {
    key: 1,
    class: "single-menu-item"
};
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "title" };
const _hoisted_13 = { class: "accordion__intro" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("button", { class: "toggle-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--add-fill" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--subtract-fill" })
], -1);
const _hoisted_15 = { class: "accordion__content" };
const _hoisted_16 = ["value"];
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-right-line" }, null, -1);
const _hoisted_18 = { class: "title" };
const _hoisted_19 = {
    key: 3,
    class: "single-menu-item"
};
const _hoisted_20 = ["value"];
const _hoisted_21 = { class: "title" };
const _hoisted_22 = { class: "accordion__intro" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("button", { class: "toggle-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--add-fill" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--subtract-fill" })
], -1);
const _hoisted_24 = { class: "accordion__content" };
const _hoisted_25 = ["value"];
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-right-line" }, null, -1);
const _hoisted_27 = { class: "title" };
const _hoisted_28 = {
    key: 5,
    class: "single-menu-item"
};
const _hoisted_29 = ["value"];
const _hoisted_30 = { class: "title" };
const _hoisted_31 = { class: "accordion__intro" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("button", { class: "toggle-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--add-fill" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--subtract-fill" })
], -1);
const _hoisted_33 = { class: "accordion__content" };
const _hoisted_34 = ["value"];
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--arrow-right-line" }, null, -1);
const _hoisted_36 = { class: "title" };
const _hoisted_37 = {
    key: 7,
    class: "single-menu-item"
};
const _hoisted_38 = ["value"];
const _hoisted_39 = { class: "title" };
const _hoisted_40 = { class: "single-menu-item" };
const _hoisted_41 = ["href"];
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--map-pin-line btn__icon" }, null, -1);
const _hoisted_43 = { id: "companies-map-container" };
const _hoisted_44 = { class: "map-placeholder companies-map-placeholder" };
const _hoisted_45 = { id: "countries-map-container" };
const _hoisted_46 = { class: "map-placeholder countries-map-placeholder" };
const _hoisted_47 = ["innerHTML"];
const _hoisted_48 = { class: "map-country" };
const _hoisted_49 = { class: "countries-select" };
const _hoisted_50 = {
    value: "",
    disabled: ""
};
const _hoisted_51 = ["value"];
const _hoisted_52 = { class: "map-company" };
const _hoisted_53 = { class: "map-groups" };
const _hoisted_54 = { class: "group-wrapper" };
const _hoisted_55 = ["href"];
const _hoisted_56 = { class: "contact-list" };
const _hoisted_57 = {
    key: 0,
    class: "contact-title"
};
const _hoisted_58 = ["innerHTML"];
const _hoisted_59 = { class: "contact-phones" };
const _hoisted_60 = ["href"];
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--phone-line" }, null, -1);
const _hoisted_62 = ["href"];
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--phone-line" }, null, -1);
const _hoisted_64 = ["href"];
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--phone-line" }, null, -1);
const _hoisted_66 = { class: "contact-emails" };
const _hoisted_67 = ["href"];
const _hoisted_68 = ["href"];
const _hoisted_69 = ["href"];
const _hoisted_70 = ["src"];
const _hoisted_71 = ["src"];
import { onMounted, ref, computed, nextTick } from "vue";
import { __ } from '../js/helpers/i18n';
import { asset } from "../js/helpers/others";
import { customSelect } from '../js/functions/custom-forms';
export default /*#__PURE__*/ _defineComponent({
    props: {
        urlMarkers: { type: String, required: true },
        urlMarkerInfo: { type: String, required: true },
        urlContacts: { type: String, required: true },
        urlCountriesPolygons: { type: String, required: true },
        id: { type: [String, Number], required: true },
        initialZoom: { type: Number, required: true },
        locale: { type: String, required: true },
        hideSectors: { type: String, required: true },
        sectorMapType: { type: String, required: true },
        mapKey: { type: String, required: true },
        svgMapCode: { type: String, required: true },
        companies: { type: Array, required: true },
        sectors: { type: Array, required: true },
        countries: { type: Array, required: true },
        departments: { type: Array, required: true },
        forms: { type: Array, required: true },
        links: { type: Array, required: true }
    },
    setup(__props) {
        const props = __props;
        let countriesMap = null;
        let companiesMap = null;
        let countriesPolygons = [];
        const companies = props.companies;
        const sectors = props.sectors;
        const countries = props.countries;
        const departments = props.departments;
        const forms = props.forms;
        const links = props.links;
        const sectorMapType = props.sectorMapType;
        const svgMapCode = props.svgMapCode;
        const hideSectors = props.hideSectors;
        let contacts = ref([]);
        const sector = ref(null);
        const department = ref(null);
        const form = ref(null);
        const company = ref(null);
        const country = ref(null);
        const location = ref({});
        let initialZoom;
        let geolocationAvailable = true;
        let geocoder;
        let markers = [];
        const urlSearchParams = new URLSearchParams(window.location.search);
        const hasDepartmentUrlParam = computed(() => urlSearchParams.has('department'));
        const hasFormUrlParam = computed(() => urlSearchParams.has('form'));
        const hasCompanyUrlParam = computed(() => urlSearchParams.has('company'));
        const displayType = ref(hasDepartmentUrlParam.value ? 'department-form' : 'countries-map');
        let mapIsLoaded = false;
        if (sectorMapType == 'svg') {
            displayType.value = hasDepartmentUrlParam.value ? 'department-form' : 'sectors-svg-map';
        }
        let filteredCountries = computed(() => {
            return sector.value == null
                ? countries
                : countries.filter(obj => obj.sector_id === sector.value);
        });
        const countriesMapStyle = [
            {
                featureType: 'all',
                elementType: 'geometry',
                stylers: [{ color: '#f0f0f0' }] // Light gray for everything.
            },
            {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                stylers: [{ color: '#DCE0DF' }] // Very light gray for the land.
            },
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [{ color: '#EFEFEF' }] // Light gray for the oceans.
            },
            {
                featureType: 'poi',
                stylers: [{ visibility: 'off' }] // Hide all points of interest (POI).
            },
            {
                featureType: 'transit',
                stylers: [{ visibility: 'off' }] // Hide transit stations and lines.
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ visibility: 'off' }] // Hide roads completely.
            },
            {
                featureType: 'road',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }] // Hide road labels.
            },
            {
                featureType: 'administrative.country',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#ffffff' }] // White country borders.
            },
            {
                featureType: 'administrative.country',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#777777' }] // Set country name labels to #777777.
            },
            {
                featureType: 'administrative.locality',
                elementType: 'geometry',
                stylers: [{ visibility: 'off' }] // Hide city dots (geometry).
            },
            {
                featureType: 'administrative.locality',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }] // Hide city/locality names.
            },
            {
                featureType: 'administrative.neighborhood',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }] // Hide neighborhood labels.
            },
            {
                featureType: 'administrative.province',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }] // Hide province/state labels.
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#777777' }] // Set sea/ocean names to #777777.
            }
        ];
        const handleBeforeLeave = (el) => {
            const rect = el.getBoundingClientRect();
            const parentRect = el.parentElement.getBoundingClientRect();
            el.style.position = 'absolute';
            el.style.width = `${rect.width}px`;
            el.style.height = `${rect.height}px`;
            el.style.top = `${rect.top - parentRect.top}px`;
            el.style.left = `${rect.left - parentRect.left}px`;
        };
        const selectedSector = computed(() => getFromListById(sectors, sector.value));
        const selectedCountry = computed(() => getFromListById(countries, country.value));
        const selectedDepartment = computed(() => getFromListById(departments, department.value));
        const selectedForm = computed(() => getFromListById(forms, form.value));
        const selectedCompany = computed(() => getFromListById(companies, company.value));
        const resizeIframe = (iframeRef) => {
            if (iframeRef.value && iframeRef.value.contentWindow) {
                const iframeDoc = iframeRef.value.contentWindow.document;
                const iframeBody = iframeDoc.body;
                if (!iframeBody)
                    return;
                const updateHeight = () => {
                    iframeRef.value.style.height = `${iframeBody.scrollHeight}px`;
                };
                updateHeight();
                iframeDoc.addEventListener('input', updateHeight);
                const observer = new MutationObserver(updateHeight);
                observer.observe(iframeBody, { childList: true, subtree: true, attributes: true });
            }
        };
        const iframeDepartmentForm = ref(null);
        const iframeForm = ref(null);
        const resizeIframeDepartmentForm = () => resizeIframe(iframeDepartmentForm);
        const resizeIframeContactForm = () => resizeIframe(iframeForm);
        onMounted(() => {
            initialZoom = props.initialZoom;
            if (!("geolocation" in navigator)) {
                geolocationAvailable = false;
            }
            setDepartmentByQuery();
            setFormByQuery();
            setCompanyByQuery();
            if (hideSectors) {
                setDefaultCountry();
            }
            else {
                setDefaultSector();
            }
            window.addEventListener("mousemove", () => initialize(), { once: true });
            window.addEventListener("keydown", () => initialize(), { once: true });
        });
        const loadGoogleMaps = () => {
            const script = document.createElement("script");
            script.src = "https://maps.googleapis.com/maps/api/js?key=" + props.mapKey + "&libraries=marker&loading=async";
            script.async = true;
            document.body.appendChild(script);
        };
        const initialize = () => {
            if (mapIsLoaded) {
                return;
            }
            loadGoogleMaps();
            mapIsLoaded = true;
            setTimeout(() => {
                initCompaniesMap();
                initCountriesMap();
                initSectorsMap();
                setCompanyByQuery();
                if (hideSectors) {
                    setDefaultCountry();
                }
                else {
                    setDefaultSector();
                }
            }, 500);
        };
        const mapContentRef = ref(null);
        function scrollToHead() {
            const headerElement = document.querySelector('.header');
            const headerHeight = headerElement?.offsetHeight || 0;
            if (mapContentRef.value) {
                const elementPosition = mapContentRef.value.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - headerHeight;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
        const onChangeSector = () => {
            country.value = null;
            company.value = null;
            department.value = null;
            form.value = null;
            contacts.value = [];
            if (sectorMapType == 'svg') {
                displayType.value = 'sectors-svg-map';
                getContacts();
            }
            else {
                displayType.value = 'countries-map';
            }
            updateMapToSelectedSector();
            scrollToHead();
            setDepartmentQueryParam();
            nextTick(() => {
                customSelect(true);
            });
        };
        const onChangeDepartment = () => {
            country.value = null;
            company.value = null;
            sector.value = null;
            form.value = null;
            displayType.value = 'department-form';
            scrollToHead();
            setDepartmentQueryParam();
            nextTick(() => {
                customSelect(true);
            });
        };
        const onChangeForm = () => {
            country.value = null;
            company.value = null;
            sector.value = null;
            displayType.value = 'contact-form';
            scrollToHead();
            setFormQueryParam();
            nextTick(() => {
                customSelect(true);
            });
        };
        const onChangeCompany = () => {
            country.value = null;
            sector.value = null;
            department.value = null;
            form.value = null;
            displayType.value = 'companies-map';
            getContacts();
            scrollToHead();
            let contactMarkers = [];
            selectedCompany.value.markersData.forEach((markerData) => {
                contactMarkers.push({
                    marker_lat: markerData.marker_lat,
                    marker_lng: markerData.marker_lng,
                    id: markerData.id,
                    marker_type: markerData.marker_type
                });
            });
            if (contactMarkers.length != 0) {
                insertMarkers(contactMarkers);
            }
            else {
                clearMarkers();
            }
            setCompanyQueryParam();
            nextTick(() => {
                customSelect(true);
            });
        };
        const onChangeCountry = () => {
            department.value = null;
            company.value = null;
            form.value = null;
            displayType.value = 'countries-map';
            if (country.value) {
                let countryItem = getFromListById(countries, country.value);
                sector.value = countryItem.sector_id;
            }
            getContacts();
            nextTick(() => {
                customSelect(true);
            });
            updateMapToSelectedSector();
        };
        const setDefaultSector = () => {
            if (hasDepartmentUrlParam.value || hasCompanyUrlParam.value || hasFormUrlParam.value) {
                return;
            }
            sector.value = (sectors.find(obj => obj.is_default) || sectors[0])?.id ?? null;
            updateMapToSelectedSector();
            if (sectorMapType == 'svg') {
                getContacts();
            }
            nextTick(() => {
                customSelect(true);
            });
        };
        const setDefaultCountry = () => {
            if (hasDepartmentUrlParam.value || hasCompanyUrlParam.value || hasFormUrlParam.value) {
                return;
            }
            company.value = companies.length > 0 ? companies[0].id : null;
            onChangeCompany();
        };
        const updateMapToSelectedSector = () => {
            if (!mapIsLoaded)
                return;
            if (sectorMapType == 'google') {
                if (selectedSector.value) {
                    countriesMap.setCenter({
                        lat: parseFloat(selectedSector.value.center_lat),
                        lng: parseFloat(selectedSector.value.center_lng)
                    });
                    countriesMap.setZoom(parseInt(selectedSector.value.center_zoom));
                }
            }
            if (sectorMapType == 'svg') {
                document.querySelectorAll(".sector").forEach((sector) => {
                    sector.classList.remove("active");
                });
                document.getElementById(selectedSector.value.svg_attribute_id).classList.add("active");
            }
        };
        const setDepartmentByQuery = () => {
            if (hasDepartmentUrlParam.value) {
                let departmentId = parseInt(decodeURI(urlSearchParams.get('department')));
                department.value = departments.filter((obj) => obj.id == departmentId).find((e) => !!e).id;
                onChangeDepartment();
            }
        };
        const setFormByQuery = () => {
            if (hasFormUrlParam.value) {
                let formId = parseInt(decodeURI(urlSearchParams.get('form')));
                form.value = forms.filter((obj) => obj.id == formId).find((e) => !!e).id;
                onChangeForm();
            }
        };
        const setCompanyByQuery = () => {
            if (hasCompanyUrlParam.value) {
                let companyId = parseInt(decodeURI(urlSearchParams.get('company')));
                company.value = companies.filter((obj) => obj.id == companyId).find((e) => !!e).id;
                onChangeCompany();
            }
        };
        const setDepartmentQueryParam = () => {
            if (history.pushState) {
                let queryString = '';
                if (department.value != null) {
                    urlSearchParams.delete('form');
                    urlSearchParams.delete('company');
                    urlSearchParams.set('department', `${department.value}`);
                    queryString = '?' + urlSearchParams;
                }
                else {
                    urlSearchParams.delete('department');
                }
                let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                history.replaceState(undefined, undefined, url + queryString);
            }
        };
        const setFormQueryParam = () => {
            if (history.pushState) {
                let queryString = '';
                if (form.value != null) {
                    urlSearchParams.delete('department');
                    urlSearchParams.delete('company');
                    urlSearchParams.set('form', `${form.value}`);
                    queryString = '?' + urlSearchParams;
                }
                else {
                    urlSearchParams.delete('form');
                }
                let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                history.replaceState(undefined, undefined, url + queryString);
            }
        };
        const setCompanyQueryParam = () => {
            if (history.pushState) {
                let queryString = '';
                if (company.value != null) {
                    urlSearchParams.delete('form');
                    urlSearchParams.delete('department');
                    urlSearchParams.set('company', `${company.value}`);
                    queryString = '?' + urlSearchParams;
                }
                else {
                    urlSearchParams.delete('company');
                }
                let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
                history.replaceState(undefined, undefined, url + queryString);
            }
        };
        const getFromListById = (list, id) => {
            return list.filter((obj) => obj.id == id).find((e) => !!e);
        };
        const getContacts = () => {
            fetch(`${props.urlContacts}?${new URLSearchParams({
                locale: props.locale,
                sector_id: sector.value ? `${sector.value}` : '',
                country_id: country.value ? `${country.value}` : '',
                company_id: company.value ? `${company.value}` : ''
            })}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": token
                }
            })
                .then((response) => { return response.json(); })
                .then((response) => {
                contacts.value = response;
            })
                .catch((error) => {
                console.log(error);
            });
        };
        function createCustomMarkerIcon(iconUrl) {
            const iconElement = document.createElement('div');
            iconElement.classList.add('custom-marker-icon');
            const img = document.createElement('img');
            img.src = iconUrl;
            img.alt = 'Marker Icon';
            iconElement.appendChild(img);
            return iconElement;
        }
        const intersectionObserver = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('drop');
                    intersectionObserver.unobserve(entry.target);
                }
            }
        });
        const insertMarkers = (markersData) => {
            if (!markersData.length)
                return;
            if (!mapIsLoaded)
                return;
            clearMarkers();
            let bounds = new window.google.maps.LatLngBounds();
            markersData.forEach((markerData) => {
                const marker = new window.google.maps.marker.AdvancedMarkerElement({
                    map: companiesMap,
                    position: {
                        lat: parseFloat(markerData.marker_lat),
                        lng: parseFloat(markerData.marker_lng)
                    },
                    content: createCustomMarkerIcon(asset('icons/map-pin-2-fill.svg'))
                });
                marker.addListener('click', function () {
                    if (markerData.marker_type == 'link') {
                        const googleMapsUrl = `https://www.google.com/maps/dir//${markerData.marker_lat},${markerData.marker_lng}/@${markerData.marker_lat},${markerData.marker_lng},500m/data=!3m1!1e3!4m2!4m1!3e0`;
                        window.open(googleMapsUrl, '_blank');
                    }
                    else if (markerData.marker_type == 'popup') {
                        markerInfo(markerData, marker, companiesMap, false);
                    }
                    else if (markerData.marker_type == 'popup-with-navi-button') {
                        markerInfo(markerData, marker, companiesMap, true);
                    }
                });
                bounds.extend(marker.position);
                markers.push(marker);
                // Marker animation
                const content = marker.content;
                content.style.opacity = '0';
                content.addEventListener('animationend', () => {
                    content.classList.remove('drop');
                    content.style.opacity = '1';
                });
                const time = .5;
                content.style.setProperty('--delay-time', time + 's');
                intersectionObserver.observe(content);
            });
            companiesMap.fitBounds(bounds);
            if (companiesMap.getZoom() > 8) {
                let listener = window.google.maps.event.addListener(companiesMap, "idle", function () {
                    window.google.maps.event.removeListener(listener);
                    companiesMap.setZoom(initialZoom);
                });
            }
        };
        const clearMarkers = () => {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
        };
        const markerInfo = (markerData, marker, map, popupWithNaviButton = false) => {
            let id = markerData.id.toString();
            fetch(`${props.urlMarkerInfo}?${new URLSearchParams({
                marker_id: id,
                locale: props.locale
            })}`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": token,
                }
            })
                .then((response) => { return response.text(); })
                .then((response) => {
                let infowindow = window.infowindow;
                if (infowindow) {
                    infowindow.close();
                }
                let content = response;
                if (popupWithNaviButton) {
                    const googleMapsUrl = `https://www.google.com/maps/dir//${markerData.marker_lat},${markerData.marker_lng}/@${markerData.marker_lat},${markerData.marker_lng},500m/data=!3m1!1e3!4m2!4m1!3e0`;
                    content += `<br><a class="btn btn-green-light" target="_blank" href="${googleMapsUrl}">Wyznacz trasę</a>`;
                }
                infowindow = new window.google.maps.InfoWindow({
                    content: content,
                    maxWidth: 'auto',
                });
                infowindow.open(map, marker);
            })
                .catch((error) => {
                console.log(error);
            });
        };
        const initCompaniesMap = () => {
            const mapContainer = document.getElementById('companies-map-container');
            if (!mapContainer)
                return;
            companiesMap = new window.google.maps.Map(mapContainer, {
                zoom: initialZoom,
                // Set all controls to be enabled but hide them visually using CSS.
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
                zoomControl: true,
                disableDefaultUI: true,
                mapId: 'companies-' + props.id.toString()
            });
            geocoder = new window.google.maps.Geocoder();
        };
        const initCountriesMap = () => {
            if (sectorMapType == 'svg') {
                return;
            }
            const mapContainer = document.getElementById('countries-map-container');
            if (!mapContainer)
                return;
            countriesMap = new window.google.maps.Map(mapContainer, {
                zoom: 3,
                minZoom: 1,
                center: { lat: -34.397, lng: 150.644 },
                mapTypeId: 'roadmap',
                backgroundColor: 'none',
                mapId: 'countries-' + props.id.toString()
            });
            const styledMapType = new window.google.maps.StyledMapType(countriesMapStyle);
            countriesMap.mapTypes.set('styled_map', styledMapType);
            countriesMap.setMapTypeId('styled_map');
            fetch(`${props.urlCountriesPolygons}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": token,
                }
            })
                .then((response) => { return response.json(); })
                .then((response) => {
                response.forEach(function (country) {
                    let countryCoords;
                    let ca;
                    let co;
                    if ('multi' in country) {
                        let ccArray = [];
                        for (let t in country['xml']['Polygon']) {
                            countryCoords = [];
                            co = country['xml']['Polygon'][t]['outerBoundaryIs']['LinearRing']['coordinates'].split(' ');
                            for (let i in co) {
                                ca = co[i].split(',');
                                countryCoords.push(new window.google.maps.LatLng(ca[1], ca[0]));
                            }
                            ccArray.push(countryCoords);
                        }
                        createCountry(ccArray, country);
                    }
                    else {
                        countryCoords = [];
                        co = country['xml']['outerBoundaryIs']['LinearRing']['coordinates'].split(' ');
                        for (let j in co) {
                            ca = co[j].split(',');
                            countryCoords.push(new window.google.maps.LatLng(ca[1], ca[0]));
                        }
                        createCountry(countryCoords, country);
                    }
                });
                showCountries();
            })
                .catch((error) => {
                console.log(error);
            });
        };
        const initSectorsMap = () => {
            document.querySelectorAll(".sector").forEach((sectorElement) => {
                sectorElement.addEventListener("click", function () {
                    document.querySelectorAll(".sector").forEach(s => s.classList.remove("active"));
                    let sectorId = this.id;
                    let selectedSector = sectors.filter((obj) => obj.svg_attribute_id == sectorId).find((e) => !!e);
                    sector.value = selectedSector.id;
                    onChangeSector();
                });
            });
        };
        const showCountries = () => {
            for (let i = 0; i < countriesPolygons.length; i++) {
                countriesPolygons[i].setMap(countriesMap);
                window.google.maps.event.addListener(countriesPolygons[i], "mouseover", function () {
                    let countryId = countries.filter(obj => { return obj.iso_code == this.code; }).find((e) => !!e)?.id;
                    if (countryId != undefined) {
                        this.setOptions({ fillColor: "#046A38", 'fillOpacity': 0.5 });
                    }
                });
                window.google.maps.event.addListener(countriesPolygons[i], "mouseout", function () {
                    let countryId = countries.filter(obj => { return obj.iso_code == this.code; }).find((e) => !!e)?.id;
                    if (countryId != undefined) {
                        this.setOptions({ fillColor: "#142C29", 'fillOpacity': 0.2 });
                    }
                    else {
                        this.setOptions({ fillColor: "#DCE0DF", 'fillOpacity': 0.2 });
                    }
                });
                window.google.maps.event.addListener(countriesPolygons[i], 'click', function () {
                    setCountryByIsoCode(this.code, false);
                });
            }
        };
        const createCountry = (coords, country) => {
            let countryId = countries.filter(obj => { return obj.iso_code == country.iso; }).find((e) => !!e)?.id;
            let polygonConfig = {
                paths: coords,
                //strokeColor: 'white',
                title: country.country,
                code: country.iso,
                strokeOpacity: 0,
                //strokeWeight: 1,
                fillColor: '#DCE0DF',
                fillOpacity: 0.2
            };
            if (countryId != undefined) {
                polygonConfig.fillColor = "#142C29";
            }
            let polygon = new window.google.maps.Polygon(polygonConfig);
            countriesPolygons.push(polygon);
        };
        const getLocation = () => {
            navigator.geolocation.getCurrentPosition(position => {
                location.value = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                countriesMap.setCenter({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
                searchCountryByLocation(position.coords.latitude, position.coords.longitude);
            }, function (error) {
                console.log(error);
            });
        };
        const searchCountryByLocation = (lat, lng) => {
            let latlng = new window.google.maps.LatLng(lat, lng);
            geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                if (status == window.google.maps.GeocoderStatus.OK) {
                    if (results[1]) {
                        let indice = 0;
                        for (let j = 0; j < results.length; j++) {
                            if (results[j].types[0] == 'locality') {
                                indice = j;
                                break;
                            }
                        }
                        for (var i = 0; i < results[indice].address_components.length; i++) {
                            if (results[indice].address_components[i].types[0] == "country") {
                                setCountryByIsoCode(results[indice].address_components[i].short_name, true);
                                countriesMap.setCenter({
                                    lat: lat,
                                    lng: lng
                                });
                                countriesMap.setZoom(5);
                            }
                        }
                    }
                }
                else {
                    console.log("Geocoder failed due to: " + status);
                }
            });
        };
        const setCountryByIsoCode = (isoCode, zoom) => {
            let countryId = countries.filter(obj => { return obj.iso_code == isoCode; }).find((e) => !!e)?.id;
            let countryItem = getFromListById(countries, countryId);
            if (countryItem) {
                sector.value = countryItem.sector_id;
                onChangeSector();
                country.value = countryId;
                onChangeCountry();
                if (zoom) {
                    countriesMap.setZoom(5);
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (!_unref(hideSectors) && _unref(sectors).length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["accordion", { accordion__active: !_unref(hasDepartmentUrlParam) && !_unref(hasCompanyUrlParam) }])
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("h3", null, _toDisplayString(_unref(__)('Dział sprzedaży')), 1),
                                    _hoisted_5
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sectors), (item) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                            _createElementVNode("label", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((sector).value = $event)),
                                                    value: item.id,
                                                    onChange: onChangeSector,
                                                    hidden: ""
                                                }, null, 40, _hoisted_7), [
                                                    [_vModelRadio, sector.value]
                                                ]),
                                                _hoisted_8,
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ], 2))
                            : (_unref(sectors).length == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("h3", null, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((sector).value = $event)),
                                                value: _unref(sectors)[0].id,
                                                onChange: onChangeSector,
                                                hidden: ""
                                            }, null, 40, _hoisted_11), [
                                                [_vModelRadio, sector.value]
                                            ]),
                                            _createElementVNode("strong", _hoisted_12, _toDisplayString(_unref(sectors)[0].title), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                        (_unref(companies).length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["accordion", { accordion__active: _unref(hasCompanyUrlParam) || _unref(hideSectors) }])
                            }, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("h3", null, _toDisplayString(_unref(__)('Zakłady/Spółki')), 1),
                                    _hoisted_14
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companies), (item) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                            _createElementVNode("label", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((company).value = $event)),
                                                    value: item.id,
                                                    onChange: onChangeCompany,
                                                    hidden: ""
                                                }, null, 40, _hoisted_16), [
                                                    [_vModelRadio, company.value]
                                                ]),
                                                _hoisted_17,
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(item.title), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ], 2))
                            : (_unref(companies).length == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("h3", null, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((company).value = $event)),
                                                value: _unref(companies)[0].id,
                                                onChange: onChangeCompany,
                                                hidden: ""
                                            }, null, 40, _hoisted_20), [
                                                [_vModelRadio, company.value]
                                            ]),
                                            _createElementVNode("strong", _hoisted_21, _toDisplayString(_unref(companies)[0].title), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                        (_unref(departments).length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 4,
                                class: _normalizeClass(["accordion", { accordion__active: _unref(hasDepartmentUrlParam) }])
                            }, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("h3", null, _toDisplayString(_unref(__)('Formularze kontaktowe')), 1),
                                    _hoisted_23
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(departments), (item) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                            _createElementVNode("label", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((department).value = $event)),
                                                    value: item.id,
                                                    onChange: onChangeDepartment,
                                                    hidden: ""
                                                }, null, 40, _hoisted_25), [
                                                    [_vModelRadio, department.value]
                                                ]),
                                                _hoisted_26,
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(item.title), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ], 2))
                            : (_unref(departments).length == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("h3", null, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((department).value = $event)),
                                                value: _unref(departments)[0].id,
                                                onChange: onChangeDepartment,
                                                hidden: ""
                                            }, null, 40, _hoisted_29), [
                                                [_vModelRadio, department.value]
                                            ]),
                                            _createElementVNode("strong", _hoisted_30, _toDisplayString(_unref(departments)[0].title), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                        (_unref(forms).length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 6,
                                class: _normalizeClass(["accordion", { accordion__active: _unref(hasFormUrlParam) }])
                            }, [
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("h3", null, _toDisplayString(_unref(__)('Formularze zgłoszeniowe')), 1),
                                    _hoisted_32
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(forms), (item) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                            _createElementVNode("label", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form).value = $event)),
                                                    value: item.id,
                                                    onChange: onChangeForm,
                                                    hidden: ""
                                                }, null, 40, _hoisted_34), [
                                                    [_vModelRadio, form.value]
                                                ]),
                                                _hoisted_35,
                                                _createElementVNode("span", _hoisted_36, _toDisplayString(item.title), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ], 2))
                            : (_unref(forms).length == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("h3", null, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form).value = $event)),
                                                value: _unref(forms)[0].id,
                                                onChange: onChangeForm,
                                                hidden: ""
                                            }, null, 40, _hoisted_38), [
                                                [_vModelRadio, form.value]
                                            ]),
                                            _createElementVNode("strong", _hoisted_39, _toDisplayString(_unref(forms)[0].title), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (item) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createElementVNode("h3", null, [
                                    _createElementVNode("a", {
                                        class: "title",
                                        href: item.url,
                                        target: "_blank"
                                    }, _toDisplayString(item.text), 9, _hoisted_41)
                                ])
                            ]));
                        }), 256))
                    ])
                ]),
                _createElementVNode("div", {
                    ref: (_value, _refs) => {
                        _refs['mapContentRef'] = _value;
                        mapContentRef.value = _value;
                    },
                    class: "map-content"
                }, [
                    _createVNode(_Transition, {
                        name: "fade",
                        appear: ""
                    }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                                (_unref(geolocationAvailable))
                                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-green-light",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (getLocation()))
                                    }, [
                                        _hoisted_42,
                                        _createTextVNode(" " + _toDisplayString(_unref(__)('Zlokalizuj mnie')), 1)
                                    ], 512)), [
                                        [_vShow, displayType.value == 'countries-map']
                                    ])
                                    : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("p", null, _toDisplayString(_unref(__)('Rusz myszką, aby załadować mapę!')), 1)
                                    ])
                                ], 512), [
                                    [_vShow, displayType.value == 'companies-map']
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("p", null, _toDisplayString(_unref(__)('Rusz myszką, aby załadować mapę!')), 1)
                                    ])
                                ], 512), [
                                    [_vShow, displayType.value == 'countries-map']
                                ]),
                                (!_unref(hideSectors))
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        id: "sectors-svg-map-container",
                                        innerHTML: _unref(svgMapCode)
                                    }, null, 8, _hoisted_47)), [
                                        [_vShow, displayType.value == 'sectors-svg-map']
                                    ])
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("div", _hoisted_48, [
                                        _createVNode(_Transition, {
                                            name: "fade",
                                            mode: "out-in"
                                        }, {
                                            default: _withCtx(() => [
                                                (sector.value)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("h2", {
                                                        key: sector.value,
                                                        class: "heading-2 sector"
                                                    }, _toDisplayString(_unref(selectedSector)?.title), 513)), [
                                                        [_vShow, !_unref(selectedCountry)]
                                                    ])
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_Transition, {
                                            name: "fade",
                                            mode: "out-in"
                                        }, {
                                            default: _withCtx(() => [
                                                (country.value)
                                                    ? (_openBlock(), _createElementBlock("h2", {
                                                        key: country.value,
                                                        class: "heading-2 country"
                                                    }, _toDisplayString(_unref(selectedCountry)?.title), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }),
                                        _withDirectives(_createElementVNode("div", _hoisted_49, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((country).value = $event)),
                                                onChange: onChangeCountry
                                            }, [
                                                _createElementVNode("option", _hoisted_50, _toDisplayString(_unref(__)('Wybierz kraj')), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredCountries), (item) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: item.id
                                                    }, _toDisplayString(item.title), 9, _hoisted_51));
                                                }), 256))
                                            ], 544), [
                                                [_vModelSelect, country.value]
                                            ])
                                        ], 512), [
                                            [_vShow, displayType.value == 'countries-map']
                                        ])
                                    ], 512), [
                                        [_vShow, displayType.value == 'countries-map' || displayType.value == 'sectors-svg-map']
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_52, [
                                        _createVNode(_Transition, {
                                            name: "fade",
                                            mode: "out-in"
                                        }, {
                                            default: _withCtx(() => [
                                                (company.value)
                                                    ? (_openBlock(), _createElementBlock("h3", {
                                                        key: company.value,
                                                        class: "heading-2 company"
                                                    }, _toDisplayString(_unref(selectedCompany)?.title), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ], 512), [
                                        [_vShow, displayType.value == 'companies-map']
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                        _createVNode(_TransitionGroup, { name: "fade" }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contacts), (group) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: `group-${group.group_name}`,
                                                        class: "map-group"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_54, [
                                                            _createElementVNode("h3", null, _toDisplayString(group.group_name), 1),
                                                            (group.link_url && group.link_text)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 0,
                                                                    href: group.link_url,
                                                                    class: "btn btn-green-light"
                                                                }, _toDisplayString(group.link_text), 9, _hoisted_55))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_56, [
                                                            _createVNode(_TransitionGroup, {
                                                                name: "list",
                                                                onBeforeLeave: handleBeforeLeave
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.contacts, (contact) => {
                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                            key: `contact-${contact.id}`,
                                                                            class: "contact-item"
                                                                        }, [
                                                                            (!contact.hide_title)
                                                                                ? (_openBlock(), _createElementBlock("strong", _hoisted_57, _toDisplayString(contact.title), 1))
                                                                                : _createCommentVNode("", true),
                                                                            _createElementVNode("div", {
                                                                                class: "contact-desc",
                                                                                innerHTML: contact.description
                                                                            }, null, 8, _hoisted_58),
                                                                            _createElementVNode("div", _hoisted_59, [
                                                                                (contact.phone)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 0,
                                                                                        href: `tel:${contact.phone}`
                                                                                    }, [
                                                                                        _hoisted_61,
                                                                                        _createTextVNode(" " + _toDisplayString(contact.phone), 1)
                                                                                    ], 8, _hoisted_60))
                                                                                    : _createCommentVNode("", true),
                                                                                (contact.phone2)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 1,
                                                                                        href: `tel:${contact.phone2}`
                                                                                    }, [
                                                                                        _hoisted_63,
                                                                                        _createTextVNode(" " + _toDisplayString(contact.phone2), 1)
                                                                                    ], 8, _hoisted_62))
                                                                                    : _createCommentVNode("", true),
                                                                                (contact.phone3)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 2,
                                                                                        href: `tel:${contact.phone3}`
                                                                                    }, [
                                                                                        _hoisted_65,
                                                                                        _createTextVNode(" " + _toDisplayString(contact.phone3), 1)
                                                                                    ], 8, _hoisted_64))
                                                                                    : _createCommentVNode("", true)
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_66, [
                                                                                (contact.email)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 0,
                                                                                        href: `mailto:${contact.email}`,
                                                                                        class: "btn btn-green"
                                                                                    }, _toDisplayString(contact.email), 9, _hoisted_67))
                                                                                    : _createCommentVNode("", true),
                                                                                (contact.email2)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 1,
                                                                                        href: `mailto:${contact.email}`,
                                                                                        class: "btn btn-green"
                                                                                    }, _toDisplayString(contact.email2), 9, _hoisted_68))
                                                                                    : _createCommentVNode("", true),
                                                                                (contact.email3)
                                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                                        key: 2,
                                                                                        href: `mailto:${contact.email}`,
                                                                                        class: "btn btn-green"
                                                                                    }, _toDisplayString(contact.email3), 9, _hoisted_69))
                                                                                    : _createCommentVNode("", true)
                                                                            ])
                                                                        ]));
                                                                    }), 128))
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ])
                            ], 512), [
                                [_vShow, displayType.value == 'companies-map' || displayType.value == 'countries-map' || displayType.value == 'sectors-svg-map']
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, {
                        name: "fade",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (displayType.value == 'department-form')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: _unref(selectedDepartment)?.id || `department-form-${_unref(selectedDepartment)?.form_page_url}`
                                }, [
                                    _createElementVNode("iframe", {
                                        ref: (_value, _refs) => {
                                            _refs['iframeDepartmentForm'] = _value;
                                            iframeDepartmentForm.value = _value;
                                        },
                                        onLoad: resizeIframeDepartmentForm,
                                        src: _unref(selectedDepartment)?.form_page_url,
                                        loading: "lazy",
                                        frameborder: "0",
                                        width: "100%",
                                        scrolling: "no"
                                    }, null, 40, _hoisted_70)
                                ]))
                                : (displayType.value == 'contact-form')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: _unref(selectedForm)?.id || `form-${_unref(selectedForm)?.form_page_url}`
                                    }, [
                                        _createElementVNode("iframe", {
                                            ref: (_value, _refs) => {
                                                _refs['iframeForm'] = _value;
                                                iframeForm.value = _value;
                                            },
                                            onLoad: resizeIframeContactForm,
                                            src: _unref(selectedForm)?.form_page_url,
                                            loading: "lazy",
                                            frameborder: "0",
                                            width: "100%",
                                            scrolling: "no"
                                        }, null, 40, _hoisted_71)
                                    ]))
                                    : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ], 512)
            ]));
        };
    }
});
